<template>
  <v-card flat>
    <v-card-text class="instructions-page content-500" v-if="$auth.watch.authenticated">
      <h2 class="page-title">Select your team</h2>
      <p v-if='userTeams.length === 0'>You are not a member of any teams yet</p>
      <div v-if="$auth.watch.authenticated" class="text-xs-center">
        <v-radio-group v-model="teamSelection" :mandatory="true">
          <template v-for="(team, index) in userTeams">
            <v-radio
              v-bind:key="index"
              :label="team.teamName"
              :value="team.teamId"
              color="primary"
            ></v-radio>
          </template>
        </v-radio-group>
        <v-btn @click="goToTeamHome()" color='primary' :disabled="!userTeams.length || teamSelection === null">
          <v-icon left>forward</v-icon>
          <span class="btn__text">Select Team</span>
        </v-btn>
        <v-btn @click="logout()" flat color="error">
          <v-icon left>exit_to_app</v-icon>
          <span class="btn__text">Logout</span>
        </v-btn>
      </div>
    </v-card-text>
    <div v-if="!$auth.watch.authenticated" class="text-xs-center">
      <v-alert
        v-model="accessDenied"
        icon="warning"
        color="error--text"
        class="alert--outline"
      >
        <strong>You must login before you can view this page.</strong>
      </v-alert>
      <div class="hero-wrapper">
        <v-layout column align-center justify-center>
          <h1 class="hero small-text white--text">RoomReady</h1>
          <h4 class="hero large-text white--text">Room checks made easy.</h4>
          <v-btn
            :disabled="$auth.watch.processing"
            @click="login()"
            color="primary"
          >
            <span class="custom-button btn__text netid">Login with Netid</span>
          </v-btn>
        </v-layout>
      </div>
    </div>
  </v-card>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      title: "RoomReady",
      showBrowserWarning: true,
      teamSelection: null
    }
  },
  mounted() {
    this.$auth.isLoaded().then(this.redirectAfterAuth);
  },
  computed: {
    userTeams() {
      return this.$teamService.currentUserTeams.sort( (a,b) => {
        const k = 'teamName';
        return a[k] < b[k] ? -1 : 1;
      })
    },
    accessDenied() {
      return Boolean(this.$route && this.$route.query && this.$route.query.goto);
    }
  },
  methods: {
    goToTeamHome() {
      this.$router.push({
        name: 'TeamHome',
        params: {
          teamId: this.teamSelection
        }
      });
    },
    login() {
      this.$auth.login();
      this.$auth.authWorkflowComplete().then(this.redirectAfterAuth);
    },
    logout() {
      this.$auth.logout();
    },
    redirectAfterAuth() {
      this.$nextTick(() => {
        if (
          this.$auth.watch.authenticated &&
          this.$route.query &&
          this.$route.query.goto
        ) {
          this.$router.push({ path: this.$route.query.goto });
        } else if(this.$auth.watch.authenticated && this.$auth.user().teams.length < 2) {
          this.$router.push({
            name: 'TeamHome',
            params: {
              teamId: this.$auth.user().teams[0]
            }
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue